import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const FaceContemptIcon: React.FC<IconProps> = ({ width = 32, height = 32, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#F8312F"
      />
      <path
        d="M10.5 19C12.9853 19 15 16.9853 15 14.5C15 12.0147 12.9853 10 10.5 10C8.01472 10 6 12.0147 6 14.5C6 16.9853 8.01472 19 10.5 19Z"
        fill="white"
      />
      <path
        d="M21.5 19C23.9853 19 26 16.9853 26 14.5C26 12.0147 23.9853 10 21.5 10C19.0147 10 17 12.0147 17 14.5C17 16.9853 19.0147 19 21.5 19Z"
        fill="white"
      />
      <path
        d="M14.9989 11.2899C15.0209 10.8763 14.7035 10.5231 14.2899 10.501C13.4607 10.4568 12.7846 10.2597 12.2504 9.8877C11.7235 9.52072 11.2715 8.93981 10.9612 8.01207C10.8299 7.61925 10.4049 7.40731 10.0121 7.53869C9.61925 7.67007 9.40731 8.09502 9.53869 8.48784C9.93308 9.66708 10.558 10.537 11.3932 11.1186C12.2213 11.6953 13.1929 11.9447 14.21 11.9989C14.6237 12.0209 14.9768 11.7035 14.9989 11.2899Z"
        fill="#402A32"
      />
      <path
        d="M17.001 11.2899C16.979 10.8763 17.2964 10.5231 17.71 10.501C18.5392 10.4568 19.2153 10.2597 19.7495 9.8877C20.2764 9.52072 20.7284 8.93981 21.0387 8.01207C21.1701 7.61925 21.595 7.40731 21.9878 7.53869C22.3807 7.67007 22.5926 8.09502 22.4612 8.48784C22.0668 9.66708 21.442 10.537 20.6067 11.1186C19.7786 11.6953 18.807 11.9447 17.7899 11.9989C17.3763 12.0209 17.0231 11.7035 17.001 11.2899Z"
        fill="#402A32"
      />
      <path
        d="M14 14.9999C14 16.1045 13.1046 16.9999 12 16.9999C10.8954 16.9999 10 16.1045 10 14.9999C10 13.8954 10.8954 12.9999 12 12.9999C13.1046 12.9999 14 13.8954 14 14.9999Z"
        fill="#402A32"
      />
      <path
        d="M22 14.9999C22 16.1045 21.1046 16.9999 20 16.9999C18.8954 16.9999 18 16.1045 18 14.9999C18 13.8954 18.8954 12.9999 20 12.9999C21.1046 12.9999 22 13.8954 22 14.9999Z"
        fill="#402A32"
      />
      <path
        d="M7 21.5C7 20.6716 7.67157 20 8.5 20H23.5C24.3284 20 25 20.6716 25 21.5V27.5C25 28.3284 24.3284 29 23.5 29H8.5C7.67157 29 7 28.3284 7 27.5V21.5Z"
        fill="#533566"
      />
      <path
        d="M12.1756 22.032C12.4341 22.1289 12.5651 22.4171 12.4682 22.6757L12.3465 23.0001H13.7785L14.0318 22.3246C14.1288 22.066 14.417 21.935 14.6756 22.032C14.9341 22.1289 15.0651 22.4171 14.9682 22.6757L14.8465 23.0001H15C15.2761 23.0001 15.5 23.224 15.5 23.5001C15.5 23.7763 15.2761 24.0001 15 24.0001H14.4715L14.0965 25.0001H14.5C14.7761 25.0001 15 25.224 15 25.5001C15 25.7763 14.7761 26.0001 14.5 26.0001H13.7215L13.4682 26.6757C13.3712 26.9343 13.083 27.0653 12.8244 26.9683C12.5659 26.8713 12.4349 26.5831 12.5318 26.3246L12.6535 26.0001H11.2215L10.9682 26.6757C10.8712 26.9343 10.583 27.0653 10.3244 26.9683C10.0659 26.8713 9.93488 26.5831 10.0318 26.3246L10.1535 26.0001H10C9.72386 26.0001 9.5 25.7763 9.5 25.5001C9.5 25.224 9.72386 25.0001 10 25.0001H10.5285L10.9035 24.0001H10.5C10.2239 24.0001 10 23.7763 10 23.5001C10 23.224 10.2239 23.0001 10.5 23.0001H11.2785L11.5318 22.3246C11.6288 22.066 11.917 21.935 12.1756 22.032ZM13.4035 24.0001H11.9715L11.5965 25.0001H13.0285L13.4035 24.0001Z"
        fill="white"
      />
      <path
        d="M18.9682 22.6757C19.0651 22.4171 18.9341 22.1289 18.6756 22.032C18.417 21.935 18.1288 22.066 18.0318 22.3246L16.5318 26.3246C16.4349 26.5831 16.5659 26.8713 16.8244 26.9683C17.083 27.0653 17.3712 26.9343 17.4682 26.6757L18.9682 22.6757Z"
        fill="white"
      />
      <path
        d="M19 27.0001C19.2761 27.0001 19.5 26.7763 19.5 26.5001C19.5 26.224 19.2761 26.0001 19 26.0001C18.7239 26.0001 18.5 26.224 18.5 26.5001C18.5 26.7763 18.7239 27.0001 19 27.0001Z"
        fill="white"
      />
      <path
        d="M22 22.5001C22 22.224 21.7761 22.0001 21.5 22.0001C21.2239 22.0001 21 22.224 21 22.5001V24.5001C21 24.7763 21.2239 25.0001 21.5 25.0001C21.7761 25.0001 22 24.7763 22 24.5001V22.5001Z"
        fill="white"
      />
      <path
        d="M16.5 23.0001C16.7761 23.0001 17 22.7763 17 22.5001C17 22.224 16.7761 22.0001 16.5 22.0001C16.2239 22.0001 16 22.224 16 22.5001C16 22.7763 16.2239 23.0001 16.5 23.0001Z"
        fill="white"
      />
      <path
        d="M22 26.5001C22 26.7763 21.7761 27.0001 21.5 27.0001C21.2239 27.0001 21 26.7763 21 26.5001C21 26.224 21.2239 26.0001 21.5 26.0001C21.7761 26.0001 22 26.224 22 26.5001Z"
        fill="white"
      />
    </svg>
  );
};
